var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.44655C6.58 9.44655 5.42 8.29321 5.42 6.86655C5.42 5.43988 6.58 4.29321 8 4.29321C9.42 4.29321 10.58 5.44655 10.58 6.87321C10.58 8.29988 9.42 9.44655 8 9.44655ZM8 5.29321C7.13333 5.29321 6.42 5.99988 6.42 6.87321C6.42 7.74655 7.12666 8.45321 8 8.45321C8.87333 8.45321 9.58 7.74655 9.58 6.87321C9.58 5.99988 8.86666 5.29321 8 5.29321Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1733C7.01333 15.1733 6.01999 14.7999 5.24666 14.0599C3.28 12.1666 1.10666 9.14659 1.92666 5.55325C2.66666 2.29325 5.51333 0.833252 8 0.833252C8 0.833252 8 0.833252 8.00666 0.833252C10.4933 0.833252 13.34 2.29325 14.08 5.55992C14.8933 9.15325 12.72 12.1666 10.7533 14.0599C9.97999 14.7999 8.98666 15.1733 8 15.1733ZM8 1.83325C6.06 1.83325 3.56666 2.86659 2.90666 5.77325C2.18666 8.91325 4.16 11.6199 5.94666 13.3333C7.1 14.4466 8.90666 14.4466 10.06 13.3333C11.84 11.6199 13.8133 8.91325 13.1067 5.77325C12.44 2.86659 9.93999 1.83325 8 1.83325Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2afa7fc5ed86de211b75db78c36eb6c1.svg";
export { ForwardRef as ReactComponent };